if (!customElements.get('testimonials-carousel')) {
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]'));
      this.backgrounds = Array.from(this.querySelectorAll('[data-testimonial-bg]'));
      this.dots = Array.from(this.querySelectorAll('[data-testimonial-dot]'));
      this.prevButton = this.querySelector('[data-testimonial-prev]');
      this.nextButton = this.querySelector('[data-testimonial-next]');
      this.current = 0;

      if (!this.slides.length) return;

      this.prevButton?.addEventListener('click', () => this.go(this.current - 1));
      this.nextButton?.addEventListener('click', () => this.go(this.current + 1));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.go(index));
      });

      // Swipe support: these carousels show one slide at a time via [hidden]
      // (no native scroll track underneath), so touch gets wired up here.
      // pan-y keeps vertical page scrolling native while horizontal drags
      // reach the pointer handlers below; mouse pointers are ignored so
      // desktop text selection over a quote keeps working.
      this.style.touchAction = 'pan-y';
      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        this.swipeStart = { x: event.clientX, y: event.clientY };
      });
      this.addEventListener('pointercancel', () => {
        this.swipeStart = null;
      });
      this.addEventListener('pointerup', (event) => {
        if (!this.swipeStart) return;
        const deltaX = event.clientX - this.swipeStart.x;
        const deltaY = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        // Same 40px threshold either way; the |x| > |y| check drops diagonal
        // drags that were really scroll attempts the browser let through.
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        this.go(this.current + (deltaX < 0 ? 1 : -1));
      });

      this.show(0);
      this.classList.add('is-active');
    }

    go(index) {
      const total = this.slides.length;
      this.show((index + total) % total);
    }

    show(index) {
      this.current = index;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== index;
      });
      this.backgrounds.forEach((background, i) => {
        background.hidden = i !== index;
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }
  }

  customElements.define('testimonials-carousel', TestimonialsCarousel);
}
